import { connect } from 'dva';
import { Form } from 'antd';
import { compose, mapProps } from 'recompose';
import PatientForm from './PatientForm';

export default compose(
  connect(({ errors }) => ({
    formErrors: errors.formErrors,
  })),
  mapProps(ownerProps => ({
    ...ownerProps,
    type: 'edit',
  })),
  Form.create(),
)(PatientForm);
